// src/rtkQuery/features/hooks/useNotificationService.ts

import {
  useGetNotificationsQuery,
  useAcknowledgeNotificationMutation,
  useMarkNotificationAsViewedMutation,
} from '@/rtkQuery/features/services/userNotification/userNotificationApi.slice';

export const useNotificationService = () => {
  const {
    data: notificationsData,
    error,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    status,
    refetch: refetchNotifications,
    isUninitialized, 
  } = useGetNotificationsQuery();

  const [acknowledgeNotification, acknowledgeMeta] = useAcknowledgeNotificationMutation();
  const [markNotificationAsViewed, viewedMeta] = useMarkNotificationAsViewedMutation();

  const errorMessage =
    (error as any)?.meta?.error ||
    (error as any)?.data?.message ||
    'Something went wrong while fetching notifications';

  return {
    notificationsData,
    notificationError: error,
    notificationIsLoading: isLoading,
    notificationIsFetching: isFetching,
    notificationIsSuccess: isSuccess,
    notificationIsError: isError,
    notificationIsUninitialized: isUninitialized, 
    notificationStatus: status,
    notificationErrorMessage: errorMessage,
    refetchNotifications,
    acknowledgeNotification,
    markNotificationAsViewed,
    acknowledgeMeta,  
    viewedMeta,
  };
};
